<button mat-button (click)="onSelect()">
    {{name}}
</button>